import { BulkResizeState } from "../../types";

export const deleteAllImages = (state: BulkResizeState) => {
    state.images = [];
    state.immutableImages = [];
};
